'use strict';

export default window.parkersConfig;